export default {
  title: 'Time update!',
  labels: {
    old_time: 'Previous pickup time:',
    new_time: 'New pickup time:',
  },
  buttons: {
    print: 'Print & Close',
    got_it: 'Got it',
  },
  feedback: {
    new_prep_time: 'The delivery time has been updated. Please adjust your preparation schedule accordingly.',
  },
  toasts: {
    something_went_wrong: 'Something went wrong, please try again',
  },
};
